{
  "registers": {
    "intro": "เครื่องขายทุกเครื่องของร้าน: แท็บเล็ต เครื่องพิมพ์ และลิ้นชัก เชื่อมแท็บเล็ตใหม่ด้วยรหัสที่ใช้ได้ครั้งเดียว",
    "new": "เพิ่มเครื่องขาย",
    "tabs": "เครื่องขายหรือ PIN",
    "tab_registers": "เครื่องขาย",
    "tab_pins": "PIN พนักงาน",
    "load_failed": "โหลดเครื่องขายไม่ได้",
    "empty": "ยังไม่มีเครื่องขาย",
    "empty_body": "เพิ่มเครื่องขายเครื่องแรก แล้วเชื่อมแท็บเล็ตด้วยรหัส",
    "pair": "ออกรหัสเชื่อมต่อ",
    "edit": "แก้",
    "shifts": "กะของเครื่องนี้",
    "status_active": "ใช้งาน",
    "status_disabled": "ปิดอยู่",
    "edc_note": "เครื่องรูดบัตรและค่าธรรมเนียมตั้งที่หน้าการชำระเงิน",
    "edc_link": "เปิดการชำระเงิน"
  },
  "card": {
    "location": "ร้าน",
    "shift": "กะ",
    "open_by": "เปิดโดย {{name}}",
    "closed": "ปิดแล้ว",
    "printer": "เครื่องพิมพ์ใบเสร็จ",
    "no_printer": "ไม่มีเครื่องพิมพ์",
    "drawer": "ลิ้นชักเงิน",
    "drawer_yes": "มี",
    "drawer_no": "ไม่มี"
  },
  "tablets": {
    "none": "ยังไม่มีแท็บเล็ตเชื่อมต่อ",
    "count_one": "แท็บเล็ต {{count}} เครื่อง",
    "count_other": "แท็บเล็ต {{count}} เครื่อง",
    "online": "ออนไลน์",
    "last_seen": "ใช้ล่าสุด",
    "never": "ยังไม่เคยใช้",
    "revoke": "ยกเลิกการเชื่อมต่อ",
    "revoke_title": "ยกเลิกการเชื่อมต่อแท็บเล็ตนี้?",
    "revoke_consequence": "แท็บเล็ตใช้ไม่ได้ทันที ทุกคนที่ล็อกอินอยู่จะถูกออก เชื่อมใหม่ได้ด้วยรหัสใหม่",
    "revoked": "ยกเลิกการเชื่อมต่อแล้ว"
  },
  "form": {
    "new_title": "เพิ่มเครื่องขาย",
    "edit_title": "แก้ {{name}}",
    "name": "ชื่อ",
    "name_hint": "ชื่อที่พนักงานเรียก เช่น \"เคาน์เตอร์ 1\"",
    "code": "รหัสสั้น",
    "code_hint": "พิมพ์บนใบเสร็จ เช่น REG-1",
    "location": "ร้าน",
    "drawer": "ลิ้นชักเงินสด",
    "drawer_hint": "เปิดเมื่อขายเงินสดเสร็จ",
    "printer": "เครื่องพิมพ์ใบเสร็จ",
    "ip": "ที่อยู่เครื่องพิมพ์ (IP)",
    "ip_hint": "ดูได้จากใบทดสอบของเครื่องพิมพ์ เช่น 192.168.1.50",
    "bt": "ชื่อ Bluetooth",
    "bt_hint": "ชื่อเครื่องพิมพ์ในรายการ Bluetooth ของแท็บเล็ต",
    "paper": "ความกว้างกระดาษ",
    "active": "ใช้งาน",
    "required": "กรอกช่องนี้",
    "create": "บันทึกแล้วเชื่อมแท็บเล็ต",
    "save": "บันทึก",
    "created": "เพิ่มเครื่องขายแล้ว",
    "saved": "บันทึกแล้ว"
  },
  "printer": {
    "network": "LAN / Wi-Fi",
    "network_help": "เครื่องพิมพ์อยู่ในเครือข่ายของร้าน ใส่ที่อยู่ที่พิมพ์ในใบทดสอบ",
    "bluetooth": "Bluetooth",
    "bluetooth_help": "จับคู่เครื่องพิมพ์กับแท็บเล็ตก่อน แล้วใส่ชื่อที่นี่",
    "webusb": "สาย USB",
    "webusb_help": "ต่อเครื่องพิมพ์กับแท็บเล็ตด้วยสาย แท็บเล็ตจะขออนุญาตครั้งแรก",
    "sunmi": "ในตัวเครื่อง (Sunmi)",
    "sunmi_help": "เครื่องพิมพ์อยู่ในเครื่อง Sunmi ไม่ต้องกรอกอะไร",
    "none": "ไม่มีเครื่องพิมพ์",
    "none_help": "ส่งใบเสร็จทางอีเมลอย่างเดียว"
  },
  "pairing": {
    "title": "เชื่อมแท็บเล็ตกับ {{name}}",
    "intro": "พิมพ์รหัสนี้บนแท็บเล็ตภายในเวลาที่แสดง รหัสใช้ได้ครั้งเดียว",
    "making": "กำลังออกรหัส…",
    "code_label": "รหัส {{code}}",
    "left": "เหลือ {{time}}",
    "expired": "รหัสนี้หมดเวลาแล้ว",
    "again": "ออกรหัสใหม่",
    "qr": "QR สำหรับแท็บเล็ต",
    "step1": "เปิดแอปเครื่องขายบนแท็บเล็ต",
    "step2": "แท็บเล็ตจะแสดงหน้า “ลงทะเบียนเครื่อง” รหัสด้านล่างจะเชื่อมกับ {{name}} ({{code}}) ให้เอง ไม่ต้องเลือกเครื่อง",
    "step3": "พิมพ์รหัสนี้ (หรือสแกน QR)",
    "once": "รหัสแสดงที่นี่เท่านั้น ปิดหน้าต่างแล้วรหัสจะหายไป",
    "close": "ปิด"
  },
  "pin": {
    "intro": "PIN ที่พนักงานใช้ที่เครื่องขาย การรีเซ็ตจะถามก่อนและถูกบันทึก",
    "has": "มี PIN",
    "none": "ไม่มี PIN",
    "reset": "รีเซ็ต PIN",
    "load_failed": "โหลดรายชื่อพนักงานไม่ได้",
    "title": "รีเซ็ต PIN ของ {{name}}?",
    "consequence": "PIN เดิมใช้ไม่ได้ทันที",
    "how": "PIN ใหม่",
    "temporary": "PIN ชั่วคราว",
    "temporary_hint": "แสดงที่นี่ครั้งเดียว บอกพนักงาน แล้วให้ตั้งเองที่เครื่องขาย",
    "clear": "ไม่มี PIN ให้ตั้งเองที่เครื่องขาย",
    "clear_hint": "ล็อกอินด้วยรหัสผ่านครั้งเดียวแล้วตั้ง PIN",
    "cancel": "ไม่รีเซ็ต",
    "confirm": "รีเซ็ต PIN",
    "shown_once": "บอก PIN นี้กับพนักงานตอนนี้ จะไม่แสดงอีก",
    "cleared": "ลบ PIN แล้ว ให้พนักงานตั้งใหม่ที่เครื่องขาย",
    "done": "เสร็จ"
  },
  "receipt": {
    "header_title": "ส่วนหัวใบเสร็จ",
    "shop_name": "ชื่อร้าน",
    "tnumber": "登録番号 (เลขผู้ออกใบกำกับ)",
    "kobutsu": "古物商許可番号",
    "address": "ที่อยู่ · โทร",
    "not_set": "ยังไม่ได้ตั้ง",
    "placeholder": "เลขตัวอย่าง ยังไม่ใช่เลขจริง",
    "change_in_tax": "แก้ที่การตั้งค่าภาษี",
    "change_in_store": "แก้ที่ข้อมูลร้าน",
    "texts_note": "ข้อความขอบคุณและกฎการคืนสินค้ามาจากการตั้งค่าระบบ การแก้ที่นี่จะมีภายหลัง",
    "preview_label": "ตัวอย่างใบเสร็จ",
    "preview_caption": "ใบเสร็จ 80 mm ตามการตั้งค่าในหน้านี้ (การ์ดตัวอย่าง)",
    "no_name": "(ชื่อร้าน)",
    "consigned_note": "การ์ดฝากขายพิมพ์แยกจากสินค้าของร้านที่ส่วนนี้",
    "qr_line": "สแกนเพื่อดูใบเสร็จดิจิทัล"
  },
  "rules": {
    "intro": "วิธีทำงานของเครื่องขาย: ตอนออฟไลน์ ส่วนลด รับซื้อ เก็บของให้ลูกค้า ป้าย แต่ละข้อมีคำอธิบาย",
    "tabs": "กฎหรือใบเสร็จ",
    "tab_rules": "กฎ",
    "tab_receipt": "ใบเสร็จ",
    "load_failed": "โหลดกฎเครื่องขายไม่ได้",
    "groups": {
      "offline": "ตอนเน็ตหลุด",
      "money": "ส่วนลดและลิ้นชักเงิน",
      "buylist": "รับซื้อ (買取)",
      "holds": "เก็บของให้ลูกค้า (取り置き)",
      "labels": "ป้ายและ 古物台帳",
      "tax_free": "ขายปลอดภาษี (免税)",
      "receipt": "ใบเสร็จ"
    },
    "tax_free_on": "ตั้งใบอนุญาตขายปลอดภาษีแล้ว",
    "tax_free_needs_licence": "ตั้งค่าใบอนุญาต 輸出物品販売場 ก่อน",
    "tax_free_link": "เปิดการตั้งค่าภาษี",
    "default": "กลับไปค่ามาตรฐาน ({{value}})",
    "save": "บันทึกกฎ",
    "saved": "บันทึกแล้ว เครื่องขายใช้กฎใหม่ภายใน 1 นาที",
    "changed_one": "เปลี่ยน {{count}} ข้อ",
    "changed_other": "เปลี่ยน {{count}} ข้อ",
    "nothing": "ไม่มีการเปลี่ยน",
    "read_only": "เจ้าของร้านเท่านั้นที่เปลี่ยนกฎได้",
    "problems": {
      "number": "ใส่เลขจำนวนเต็ม",
      "min": "อย่างน้อย {{min}}",
      "max": "ไม่เกิน {{max}}",
      "choice": "เลือกหนึ่งข้อ",
      "text": "กรอกช่องนี้"
    }
  },
  "units": {
    "minutes": "นาที",
    "percent": "%",
    "days": "วัน",
    "count": "รายการ",
    "yen": "เยน"
  },
  "choices": {
    "defaultDocumentType": {
      "kani_invoice": "ใบเสร็จอย่างง่าย (適格簡易請求書)",
      "tekikaku_invoice": "ใบกำกับเต็ม (適格請求書)"
    },
    "defaultReceiptMode": {
      "print": "กระดาษ",
      "email": "อีเมล",
      "print_and_email": "กระดาษและอีเมล",
      "ask": "ถามทุกครั้ง"
    },
    "labelSizeDefault": {
      "40x30": "40 × 30 mm",
      "58x40": "58 × 40 mm"
    }
  },
  "shifts": {
    "title": "กะ",
    "intro": "ทุกกะของเครื่องขาย พร้อมยอดขาย เงินขาด/เกิน และ Z-report เปิดและปิดกะทำที่เครื่องขาย",
    "cash_intro": "เงินสดของแต่ละลิ้นชัก: เงินทอนตอนเริ่ม ยอดที่ควรมี ยอดที่นับได้ และส่วนต่าง",
    "period": "วันที่ (เวลาญี่ปุ่น)",
    "register": "เครื่องขาย",
    "only_difference": "เฉพาะที่มีเงินขาด/เกิน",
    "opened": "เปิดกะ",
    "closed": "ปิดกะ",
    "still_open": "ยังเปิดอยู่",
    "float": "เงินทอนตอนเริ่ม",
    "expected": "ควรมี",
    "counted": "นับได้",
    "variance": "เงินขาด/เกิน",
    "sales_count": "จำนวนบิล",
    "net": "ยอดขายหลังคืน",
    "fee": "ค่าธรรมเนียมบัตร",
    "z_report": "Z-report",
    "z_ready": "พร้อม",
    "z_none": "ยังไม่ปิดกะ",
    "z_pending": "กำลังทำ",
    "z_issued": "พร้อม",
    "z_unsupported": "ยังใช้ไม่ได้",
    "drawer": "ลิ้นชักเงิน",
    "approved_by": "ผู้จัดการอนุมัติส่วนต่าง: {{name}}",
    "by_tender": "ตามวิธีชำระ",
    "tender": "วิธีชำระ",
    "count": "จำนวน",
    "sales": "ยอดขาย",
    "refunds": "คืนเงิน",
    "tax": "消費税",
    "discount": "ส่วนลด",
    "pickups": "ออเดอร์เว็บที่มารับ",
    "review": "ต้องตรวจ",
    "card_fees": "ค่าธรรมเนียมเครื่องรูดบัตร",
    "status_open": "เปิดอยู่",
    "status_closed": "ปิดแล้ว",
    "cash_moves_note": "เงินเข้า/ออกแต่ละรายการพร้อมเหตุผลอยู่ใน Z-report PDF รายการแยกในหลังบ้านจะมีภายหลัง"
  },
  "tenders": {
    "cash": "เงินสด",
    "edc_external": "เครื่องรูดบัตร",
    "store_credit": "เครดิตร้าน",
    "stripe_terminal": "บัตร (Stripe)",
    "stripe_payment_link": "QR (Stripe)",
    "pay_in_store": "จ่ายที่ร้าน",
    "bank_transfer_manual": "โอนธนาคาร"
  },
  "buylist": {
    "intro": "การ์ดที่ร้านรับซื้อที่เครื่องขาย (買取) จาก 古物台帳 การรับซื้อทำที่เครื่องขาย",
    "paid": "จ่ายไป",
    "seller": "ผู้ขาย",
    "purchase": "เลขรับซื้อ",
    "no_access": "เฉพาะพนักงานที่เปิด 古物台帳 ได้เท่านั้นที่เห็นการรับซื้อ",
    "note": "วิธีจ่ายและใบรับซื้ออยู่ที่เครื่องขาย บันทึกทั้งหมดอยู่ใน 古物台帳",
    "open_ledger": "เปิด 古物台帳"
  }
}
